const feedTemplate = thumbnailUrl => `
      <div class="swiper-slide">
          <div class="block-item__image">
            <img class="thumbnail" src=${thumbnailUrl} />
          </div>
      </article>
    `

export default feedTemplate
